import React from "react";
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import Loader from "../../Loader/loader";

export const RequestCallForm = () => {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId: '22438271',
        formId: 'f0891932-2134-4165-a8e5-98525cd8fbbd',
        target: '#request-call-form'
    });

    return (
        <div className="mt-4">
            {(loaded && formCreated) ? <div id="request-call-form"></div> : <Loader />}
        </div>
    );
};